import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { motion } from 'framer-motion';

const ExperienceHeader = ({ onDownloadResume }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center border border-primary/20">
          <Icon name="Briefcase" size={32} className="text-primary" />
        </div>
      </div>
      
      <h1 className="text-4xl lg:text-5xl font-bold text-text-primary mb-4">
        Work Experience
      </h1>
      
      <p className="text-lg text-text-secondary max-w-3xl mx-auto mb-8 leading-relaxed">
      Discover my professional experience as a full-stack developer at Cosmic Info Solution and previously at Iqonic Design, building products trusted by clients worldwide. Alongside my professional work, I'm developing my own AI-powered SaaS and OTT platform using modern full-stack technologies.
      </p>  
      
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Button
          variant="default"
          size="lg"
          iconName="Download"
          iconPosition="left"
          onClick={onDownloadResume}
          className="min-w-[200px]"
        >
          Download Resume
        </Button>
        
        {/* <Button
          variant="outline"
          size="lg"
          iconName="ExternalLink"
          iconPosition="right"
          onClick={() => window.open('https://linkedin.com/in/dishantmadariya', '_blank')}
          className="min-w-[200px]"
        >
          View LinkedIn Profile
        </Button> */}
      </div>
      
      <div className="mt-8 flex items-center justify-center space-x-8 text-sm text-text-secondary">
        <div className="flex items-center space-x-2">
          <Icon name="MapPin" size={16} />
          <span>Surat, Gujarat, India</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Mail" size={16} />
          <span>Available for opportunities</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Calendar" size={16} />
          <span>Updated {new Date().toLocaleDateString()}</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ExperienceHeader;